// @noflow

// Standardize the way we format displayName from Prism keys
// e.g. csharp --> .NET

// A map of unique Prism keys --> displayName that involve more than capitalizing the first char
const prismKeys = [
  {
    prism: 'curl',
    displayName: 'curl',
  },
  {
    prism: 'php',
    displayName: 'PHP',
  },
  {
    prism: 'javascript',
    displayName: 'Node',
  },
  {
    prism: 'dotnet',
    displayName: '.NET',
  },
  {
    prism: 'csharp',
    displayName: '.NET',
  },
  {
    prism: 'html',
    displayName: 'HTML',
  },
  {
    prism: 'css',
    displayName: 'CSS',
  },
  {
    prism: 'jsx',
    displayName: 'JSX',
  },
  {
    prism: 'objc',
    displayName: 'Objective-C',
  },
];

export const capitalize = (word) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

// csharp --> .NET
const fromPrismValue = (value: string) => {
  const specialCase = prismKeys.find(({prism, displayName}) => prism === value)
    ?.displayName;
  return specialCase || capitalize(value);
};

// .NET --> csharp
const toPrismValue = (value: string) => {
  const specialCase = prismKeys.find(({prism, displayName}) => prism === value)
    ?.prism;

  return specialCase || value.toLowerCase();
};

export const formatLanguage = {fromPrismValue, toPrismValue};
